<template>
  <div v-if="orderResult" class="order-details">
    <div class="border-b border-dark-b">
      <h2 class="text-xl md:text-2xl font-semibold">Order Details</h2>
    </div>
    <div class="pt-5">
      <div class="rounded-lg px-5 mb-5 py-3 md:py-6 bg-white">
        <div
          class="
            flex flex-wrap
            md:justify-between
            border-b border-dark-b
            text-lg
            font-semibold
          "
        >
          <div class="font-semibold text-lg w-full md:w-1/2">
            Order Information
          </div>
          <div
            class="
              flex
              items-center
              w-full
              pt-1
              md:pt-0
              pb-3
              md:pb-1 md:w-1/2 md:justify-end
            "
          >
            <img src="@/assets/icons/sourcingReport.svg" />
            <span class="text-base pl-2">Sourcing Report</span>
          </div>
        </div>
        <div class="flex flex-wrap pt-2 lg:pt-6">
          <div class="flex lg:flex-col w-full md:w-1/2 lg:w-1/4">
            <div class="pb-3 lg:pb-1 font-semibold">Order Placed:</div>
            <div class="pl-1 lg:pl-0">
              {{ handleDateFormatter(orderResult.order.order_date) }}
            </div>
          </div>
          <div class="flex lg:flex-col w-full md:w-1/2 lg:w-1/4">
            <div class="pb-3 lg:pb-1 font-semibold">Order Number:</div>
            <div class="pl-1 lg:pl-0">{{ orderResult.order.order_number }}</div>
          </div>
          <div class="flex lg:flex-col w-full md:w-1/2 lg:w-1/4 lg:pl-5">
            <div class="pb-3 lg:pb-1 font-semibold">Total:</div>
            <div class="pl-1 lg:pl-0">{{ orderResult.order.grand_total }}</div>
          </div>
          <div class="flex lg:flex-col w-full md:w-1/2 lg:w-1/4">
            <div class="pb-3 lg:pb-1 font-semibold">Expected Due Date:</div>
            <div class="pl-1 lg:pl-0">
              {{
                handleDateFormatter(orderResult.order.order_expected_due_date)
              }}
            </div>
          </div>
        </div>
        <div class="flex flex-wrap lg:pt-6 leading-5">
          <div class="pb-3 lg:pb-0 lg:pr-5 w-full lg:w-1/4">
            <div class="font-semibold">Billing Adress:</div>
            <div>{{ billingAddress }}</div>
          </div>
          <div class="pb-3 lg:pb-0 w-full lg:w-1/4 leading-normal">
            <div class="pb-1 font-semibold">Payment Method:</div>
            <p>Credit Card No:</p>
            <p>XXXX XXXX XXXX {{ orderResult.order.payment_last_4_digits }}</p>
          </div>
          <div class="pb-3 lg:pb-0 w-full ml-auto lg:w-1/4">
            <div class="font-semibold">
              Disclose Company Name <br class="hidden md:inline" />& Website:
            </div>
            <p>
              {{
                orderResult.company_details.can_disclose_contact_info
                  ? "Yes, you can disclose"
                  : "No, I want to be anonymous"
              }}
            </p>
          </div>
        </div>
        <div class="w-full lg:pt-9 tracking-tighter md:tracking-normal">
          <span class="pb-1 font-semibold"
            >Require Assistance? Contact us at:</span
          >
          <a :href="`mailto: ${supportMail}`" class="text-blue">
            {{ supportMail }}
          </a>
        </div>
      </div>
      <div class="rounded-lg px-5 mb-5 py-3 md:py-6 bg-white">
        <h2 class="border-b border-dark-b text-lg font-semibold">
          Product Details
        </h2>
        <div class="flex flex-wrap pt-2 md:pt-4">
          <div class="w-full md:w-1/2 lg:pr-5">
            <div class="font-semibold">Product Category:</div>
            <p>{{ orderResult.product_details.product_category }}</p>
          </div>
          <div class="w-full pt-2 md:pt-0 md:w-1/2 lg:pl-5">
            <div class="font-semibold">Sub-Category:</div>
            <p>{{ orderResult.product_details.product_sub_category }}</p>
          </div>
        </div>
        <div class="pt-2 md:pt-7">
          <div class="font-semibold">Product Name & Description:</div>
          <p v-html="orderResult.product_details.product_description"></p>
        </div>
        <div class="flex flex-wrap pt-2 md:pt-6">
          <div class="flex md:flex-col w-full md:w-1/2 lg:w-1/4">
            <div class="font-semibold">Quantity:</div>
            <div class="pl-1 md:pl-0">
              {{ orderResult.product_details.product_quantity }}
            </div>
          </div>
          <div class="flex md:flex-col w-full md:w-1/2 lg:w-1/4">
            <div class="font-semibold">Shipping terms:</div>
            <div class="pl-1 md:pl-0">
              {{ orderResult.product_details.product_shipping_terms }}
            </div>
          </div>
          <div
            class="
              flex
              md:flex-col
              w-full
              pt-2
              lg:pt-0
              md:w-1/2
              lg:w-1/4 lg:pl-14
            "
          >
            <div class="font-semibold">Packing Details:</div>
            <div class="pl-1 md:pl-0">
              <p v-html="orderResult.product_details.product_packaging_details.replaceAll('\n', '<br/>')"></p>
            </div>
          </div>
          <div
            class="
              flex
              md:flex-col
              w-full
              md:pt-2
              lg:pt-0
              md:w-1/2
              lg:w-1/4 lg:pl-16
            "
          >
            <div class="font-semibold">Safety Standards:</div>
            <div class="pl-1 md:pl-0">
              {{ orderResult.product_details.product_safety_standards }}
            </div>
          </div>
        </div>
        <div class="flex flex-wrap pt-2 md:pt-10">
          <div
            v-if="orderResult.product_details.product_images.length"
            class="w-full lg:w-1/2 lg:pr-5"
          >
            <div class="font-semibold">Product Images:</div>
            <div class="grid grid-cols-2 gap-2 lg:pb-3 lg:pr-17">
              <div
                v-for="(image, index) in orderResult.product_details
                  .product_images"
                :key="`image-${index}`"
                class="p-1"
              >
                <img @click='OpenImage(image)' :src="image.pdf_cover_url? image.pdf_cover_url : image.image_url"> 
              </div>
            </div>
          </div>
          <div
            class="w-full pt-4 lg:pt-0"
            v-if="orderResult.product_details.product_links"
            :class="{
              'lg:w-1/2 lg:pl-5':
                orderResult.product_details.product_images.length,
            }"
          >
            <div class="pb-1 font-semibold">Product Links:</div>
            <div
              v-for="(product_link, index) in orderResult.product_details
                .product_links"
              :key="index"
            >
              <a
                :href="product_link"
                class="
                  block
                  mb-2
                  md:mb-6
                  text-blue
                  leading-5
                  tracking-tight
                  underline
                  truncate
                "
              >
                {{ product_link }}
              </a>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap pt-4 md:pt-6">
          <div class="w-full md:w-1/2 lg:pr-5">
            <div class="pb-1 font-semibold">Target Price:</div>
            <p>

              {{ orderResult.product_details.product_target_price }}
            </p>
          </div>
          <div class="w-full md:w-1/2 pt-2 md:pt-0 lg:pl-5">
            <div class="pb-1 font-semibold">Decoration Specifications:</div>
            <p v-if="orderResult.product_details.product_decoration_details"  v-html="orderResult.product_details.product_decoration_details.replaceAll('\n', '<br/>')">
            </p>
          </div>
        </div>
      </div>
      <div class="rounded-lg px-5 mb-5 py-3 md:py-6 bg-white">
        <h2 class="border-b border-dark-b text-lg font-semibold">
          Supplier Details
        </h2>
        <div class="flex flex-wrap pt-2 lg:pt-6">
          <div class="w-full lg:w-1/2 lg:pr-5">
            <div
              v-if="orderResult.supplier_details.supplier_special_requirement"
            >
              <div class="font-semibold">
                Project Description or Special Requirements
              </div>
              <p v-html="orderResult.supplier_details.supplier_special_requirement"></p>
            </div>
          </div>
          <div class="w-full lg:w-1/2 lg:pl-5">
            <div
              v-if="
                orderResult.supplier_details.supplier_compliance_requirement
              "
              class="font-semibold pt-7.5 lg:pt-0"
            >
              Any Audits or Compliance Certificate required?
            </div>
            <div v-html="orderResult.supplier_details.supplier_compliance_requirement.replaceAll('\n', '<br/>')"></div>
            
            <div
              class="font-semibold pt-7.5"
              v-if="orderResult.supplier_details.supplier_region"
            >
              What countries/regions do you want your Sourcing Expert to find
              suppliers in?
            </div>
            <span
              v-for="(loc, index) in display_regions"
              :key="`region-${index}`"
            >
              <span v-if="index === 2">&</span>
              <span v-else-if="display_regions.length >= 2 && index === 1"
                >,</span
              >
              {{ loc }}
            </span>
          </div>
        </div>
        <div class="flex flex-wrap pt-8 lg:pt-3">
          <div class="w-full lg:w-1/2 lg:pr-5">
            <div class="font-semibold">
              Standard questions your Sourcing Expert will ask the suppliers
            </div>
            <ul class="list-disc list-inside">
              <li>Who is your top 3 largest customers?</li>
              <li>What is your top 3 export markets?</li>
              <li>What is your top 3 best-selling products?</li>
              <li>What is your manufacturing speciality?</li>
              <li>What are your lead times & payment terms?</li>
              <li>What is the closest FOB Port?</li>
              <li>What is your monthly production capacity?</li>
              <li>Are you a manufacturer or an agent?</li>
              <li>
                Are your products available for my market to distribute on an
                exclusive basis?
              </li>
              <li>
                What product certifications or factory audit certifications do
                you have? (a copy will be requested)
              </li>
            </ul>
          </div>
          <div
            v-if="orderResult.supplier_details.custom_questions.length"
            class="w-full lg:w-1/2 pt-8 lg:pt-0 lg:pl-5"
          >
            <div class="font-semibold">
              Up to three custom questions you would like to ask the suppliers
            </div>
            <div
              class="list-inside list-decimal"
              v-for="(question, index) in orderResult.supplier_details
                .custom_questions"
              :key="index"
            >
              {{ index + 1 }}. <div v-html="question.replaceAll('\n', '<br/>')"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end pt-3">
        <button
          class="bg-blue text-white rounded-full py-3 px-8 text-xl font-bold"
          @click="handleBackPage"
        >
          Back
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "OrderDetails",
  data() {
    return {
      orderResult: null,
      supportMail: process.env.VUE_APP_SUPPORT_MAIL,
      display_regions: [],
    };
  },

  created() {
    this.getOrderInfo();
  },

  computed: {
    billingAddress() {
      return this.orderResult.order.billing_address.replace(/ \\n/g, ",");
    },
  },

  methods: {
    ...mapActions(["fetchSourcingOrderInfo"]),

    handleBackPage() {
      this.$router.push({ name: "My Orders" });
    },

    async getOrderInfo() {
      const response = await this.fetchSourcingOrderInfo(this.$route.params.id);
      if (response.result) {
        this.orderResult = response.sourcing_request;
        this.orderResult.product_details.product_description = this.orderResult.product_details.product_description.replaceAll('\n', '<br/>')
        if(this.orderResult.supplier_details.supplier_special_requirement) {
          this.orderResult.supplier_details.supplier_special_requirement = this.orderResult.supplier_details.supplier_special_requirement.replaceAll('\n', '<br/>')
        }
        console.log(this.orderResult.product_details)
        this.setSupplierRegions();
      } else {
        this.$notify({
          group: "buyHive",
          type: "error",
          text: response.message,
        });
        this.$router.push({ name: "My Orders" });
      }
    },
    OpenImage(image){
      if(image.pdf_cover_url) {
        window.open(image.image_url, '_blank')
      }
    },
    handleDateFormatter (date) {
      return moment(date).format('DD/MM/YYYY')
    },

    setSupplierRegions() {
      this.display_regions =
        this.orderResult.supplier_details.supplier_region.map((region) => {
          return region === "Korea, Republic of" ? "South Korea" : region;
        });
    },
  },
};
</script>
